export default "__VITE_ASSET__Dl71nfvg__"